var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 251.305,
    height: 160.978,
    viewBox: "0 0 251.305 160.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task",
    transform: "translate(-153 -292.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(153 292.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M450.657,569.247c-.487,0-3.507-4.026-4.091-4.578a40.4,40.4,0,0,1-9.676-15.065c-1.623-4.156-2.825-8.6-4.156-13.247-.909-3.149-2.338-6.656-5.455-7.663-3.02-.974-6.3,1.039-8.15,3.6-1.883,2.565-2.792,5.714-4.383,8.442-2.89,5-8.02,7.078-12.241,2.695-6.039-6.266-8.766-14.805-12.6-22.468-2.792-5.552-5.13-12.046-8.6-17.176-5.357-7.792-12.7-14.448-22.436-14.448-6.169.942-11.624,6.429-15.325,13.247-3.669,6.851-5.844,14.968-7.663,23.085q-2.289,10.227-4.123,20.617c-2.305-8.344-4.74-16.624-7.338-24.741-2.825-8.8-5.942-17.6-10.292-24.643s-10.065-12.241-15.845-12.208c-8.9,1.721-14.611,10.487-18.377,20.228-2.468,6.364-3.669,14.091-5.39,20.845-2.4,9.286-3.669,19.384-8.279,27.5-3.247,5.682-8.182,4.221-11.559-.877-1.851-2.825-3.149-6.169-5.227-8.734s-5.325-4.253-7.955-2.63c-2.695,1.656-3.507,5.877-3.864,9.578-.552,5.487-1.007,10.682-1.883,15.65-.195,1.071-.39,2.143-.649,3.214h92.794c-.065.39-.13.812-.195,1.2C327.6,570.676,450.657,569.247,450.657,569.247Z",
    transform: "translate(-208.444 -422.166)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M824.868,648.247c-.227,4.773-5.455,13.15-10.228,12.89s-7.338-8.994-7.078-13.767c.227-4.773,5.325-28.734,10.13-28.475C822.433,619.155,825.1,643.474,824.868,648.247Z",
    transform: "translate(-595.025 -512.789)",
    fill: "#f1c400",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(219.875 109.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M830.33,667.127h0a.14.14,0,0,1-.13-.13l2.4-38.767a.13.13,0,1,1,.26,0L830.46,667C830.427,667.062,830.395,667.127,830.33,667.127Z",
    transform: "translate(-830.2 -628.1)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M821.654,673.132a35.218,35.218,0,0,0-2.435,7.533,6.108,6.108,0,0,0,.195,3.961,4.78,4.78,0,0,0,3.572,2.338c3.571.584,7.111-1.591,9.188-4.546,2.078-2.922,2.987-6.526,3.831-10.033a39.25,39.25,0,0,1,2.533-8.117c.52-1.1,3.6-5.357,2.143-6.461-2.013-1.558-7.792.13-11.461,4.188A41.7,41.7,0,0,0,821.654,673.132Z",
    transform: "translate(-602.752 -538.68)",
    fill: "#f1c400",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(220.103 121.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M831.03,693.976h0a.166.166,0,0,1-.13-.162c.032-.162,4.416-16.851,14.676-26.364a.145.145,0,0,1,.162,0,.107.107,0,0,1,0,.162c-10.227,9.448-14.578,26.072-14.611,26.234C831.127,693.944,831.095,693.976,831.03,693.976Z",
    transform: "translate(-830.9 -667.425)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M885.894,689.44a4.109,4.109,0,0,1-1.688,1.461c-.779.422-1.591.812-2.37,1.2-1.006.487-2.078.974-3.052,1.558a10.9,10.9,0,0,0-1.883,1.494,25.336,25.336,0,0,1,2.955-5.033c1.526-1.948,3.052-2.922,4.61-2.922h.1a1.609,1.609,0,0,1,1.1.357A1.473,1.473,0,0,1,885.894,689.44Z",
    transform: "translate(-641.862 -558.918)",
    fill: "#f1c400",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M887.952,721.18a4.171,4.171,0,0,1-2.143.584c-.877.065-1.786.065-2.662.065a29.915,29.915,0,0,0-3.409.13,10.266,10.266,0,0,0-2.338.552,22.721,22.721,0,0,1,4.838-3.279c2.208-1.1,4.026-1.331,5.422-.682.032,0,.065.033.1.065a1.714,1.714,0,0,1,.844.812A1.515,1.515,0,0,1,887.952,721.18Z",
    transform: "translate(-642.2 -579.845)",
    fill: "#f1c400",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M885.077,734.818a2.776,2.776,0,0,1-1.364-.714c-.455-.39-.909-.812-1.364-1.234-.552-.519-1.136-1.071-1.753-1.558a7.757,7.757,0,0,0-1.4-.812,16.58,16.58,0,0,1,3.929.617,4.294,4.294,0,0,1,3.02,2.208c0,.032,0,.032.032.065a1.449,1.449,0,0,1,.065.812A1.108,1.108,0,0,1,885.077,734.818Z",
    transform: "translate(-643.415 -588.159)",
    fill: "#f1c400",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(229.908 129.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M861.23,709.68a.14.14,0,0,1-.13-.13c0-.1.195-10.39,12.6-18.994.065-.032.13-.032.162.032s.033.13-.032.162c-12.273,8.539-12.468,18.7-12.468,18.8A.14.14,0,0,1,861.23,709.68Z",
    transform: "translate(-861.1 -690.534)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(229.895 140.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M861.2,731.942h-.065a.119.119,0,0,1-.065-.162,16.019,16.019,0,0,1,14.351-8.279.13.13,0,1,1,0,.26,15.755,15.755,0,0,0-14.124,8.15A.142.142,0,0,1,861.2,731.942Z",
    transform: "translate(-861.061 -723.5)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(235.59 142.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M884.931,733.679c-.032,0-.065,0-.065-.032-4.091-3.084-6.1-2.987-6.137-2.987a.13.13,0,1,1,0-.26c.1,0,2.11-.1,6.3,3.052a.113.113,0,0,1,.032.162C885,733.679,884.964,733.679,884.931,733.679Z",
    transform: "translate(-878.6 -730.399)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(23.233 101.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M276.319,635.278c-1.786-2.078-4.091-3.864-4.805-6.494-.519-1.916-.1-3.961.1-5.909s.13-4.156-1.136-5.682a7.508,7.508,0,0,0-4.318-2.143,16.712,16.712,0,0,1-4.708-1.364c-2.305-1.331-1.851-3.572-3.085-5.552-1.4-2.208-4.611-5.033-7.4-3.572-2.922,1.559-2.468,6.3-.52,8.377,1.3,1.4,2.955,2.727,3.149,4.61.292,2.857-2.955,5.39-2.078,8.117.649,2.013,3.182,2.695,4.448,4.383,1.234,1.688.974,4.058.26,6.007s-1.883,3.766-2.305,5.812c-.942,4.156,2.338,7.046,6.072,7.987,3.409.844,10.812.455,10.812.455a14.163,14.163,0,0,0,7.013-5.779,7.306,7.306,0,0,0,.39-6.364A11.1,11.1,0,0,0,276.319,635.278Z",
    transform: "translate(-240.978 -604.161)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(13.111 4.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M279.047,660.02a.14.14,0,0,1-.13-.13c-1.364-21.364-13.831-40.845-13.961-41.072-.032-.065-.032-.13.032-.162s.13-.033.162.032c.13.195,12.663,19.773,13.994,41.17.033.1,0,.162-.1.162Z",
    transform: "translate(-264.934 -618.634)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M230.12,699.46a1.31,1.31,0,0,1,.844-.26h.065c1.169,0,2.338.747,3.507,2.208a18.89,18.89,0,0,1,2.24,3.8,7.338,7.338,0,0,0-1.429-1.136,22.222,22.222,0,0,0-2.305-1.2c-.617-.292-1.234-.584-1.818-.909a2.994,2.994,0,0,1-1.266-1.1A1.136,1.136,0,0,1,230.12,699.46Z",
    transform: "translate(-228.092 -668.342)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M224.634,723.651a1.293,1.293,0,0,1,.649-.584c.032,0,.032-.033.065-.033,1.071-.487,2.435-.325,4.091.52a17.313,17.313,0,0,1,3.636,2.5,9.244,9.244,0,0,0-1.753-.422,23.444,23.444,0,0,0-2.6-.1c-.649,0-1.331,0-2.013-.032a3.136,3.136,0,0,1-1.623-.455A1.278,1.278,0,0,1,224.634,723.651Z",
    transform: "translate(-224.555 -684.254)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M233.026,734.892a.922.922,0,0,1,.032-.584.1.1,0,0,1,.032-.065,3.209,3.209,0,0,1,2.273-1.656,14.35,14.35,0,0,1,2.987-.487,6.042,6.042,0,0,0-1.071.617,15.573,15.573,0,0,0-1.331,1.169,12.732,12.732,0,0,1-1.007.909,2.357,2.357,0,0,1-1.007.552A.9.9,0,0,1,233.026,734.892Z",
    transform: "translate(-230.252 -690.561)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(2.851 31.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M242.934,716.269a.14.14,0,0,1-.13-.13c0-.065-.162-7.76-9.416-14.189a.117.117,0,0,1,.13-.195c9.383,6.526,9.546,14.319,9.546,14.384a.14.14,0,0,1-.13.13Z",
    transform: "translate(-233.334 -701.734)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(1.541 39.754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M240.209,733.061a.246.246,0,0,1-.13-.065,11.854,11.854,0,0,0-10.65-6.136.13.13,0,0,1,0-.26,12.175,12.175,0,0,1,10.877,6.266.119.119,0,0,1-.065.162A.032.032,0,0,1,240.209,733.061Z",
    transform: "translate(-229.3 -726.6)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(3.37 41.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M235.053,734.431c-.032,0-.065,0-.1-.065s-.032-.13.032-.162c3.182-2.4,4.708-2.305,4.773-2.305a.13.13,0,0,1,0,.26h0c-.032,0-1.526-.065-4.61,2.273Z",
    transform: "translate(-234.934 -731.898)",
    fill: "#0b4870"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(77.567 15.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M484.5,465.951H395.472a3.582,3.582,0,0,1-3.572-3.572V342.572A3.582,3.582,0,0,1,395.472,339h26.592v.974H395.439a2.605,2.605,0,0,0-2.6,2.6V462.38a2.605,2.605,0,0,0,2.6,2.6h89.028a2.605,2.605,0,0,0,2.6-2.6V342.572a2.605,2.605,0,0,0-2.6-2.6H457.876V339h26.592a3.582,3.582,0,0,1,3.572,3.572V462.38A3.575,3.575,0,0,1,484.5,465.951Z",
    transform: "translate(-391.9 -339)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M493.359,472.753H411.766a1.268,1.268,0,0,1-1.266-1.266V359.666a1.268,1.268,0,0,1,1.266-1.266h81.593a1.268,1.268,0,0,1,1.266,1.266V471.487A1.312,1.312,0,0,1,493.359,472.753Z",
    transform: "translate(-326.894 -336.874)",
    fill: "#019cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M397.486,759.537H159.818A6.818,6.818,0,0,1,153,752.718h0a6.817,6.817,0,0,1,6.818-6.818H397.486a6.818,6.818,0,0,1,6.818,6.818h0A6.818,6.818,0,0,1,397.486,759.537Z",
    transform: "translate(-153 -598.559)",
    fill: "#0e538c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M653.453,295.931c0,2.11-1.4,3.831-3.117,3.831H613.517c-1.721,0-3.117-1.721-3.117-3.831h0c0-2.11,1.4-3.831,3.117-3.831h36.852c1.688.032,3.084,1.753,3.084,3.831Z",
    transform: "translate(-461.89 -292.1)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M226.723,358.931a3.838,3.838,0,0,1-3.831,3.831H177.631a3.838,3.838,0,0,1-3.831-3.831h0a3.838,3.838,0,0,1,3.831-3.831h45.261a3.818,3.818,0,0,1,3.831,3.831Z",
    transform: "translate(-167.047 -334.645)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M302.767,295.931c0,2.11-1.429,3.831-3.149,3.831H262.149c-1.753,0-3.149-1.721-3.149-3.831h0c0-2.11,1.429-3.831,3.149-3.831h37.468c1.753,0,3.149,1.721,3.149,3.831Z",
    transform: "translate(-224.584 -292.1)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M757.123,346.931a3.838,3.838,0,0,1-3.831,3.831H708.031a3.838,3.838,0,0,1-3.831-3.831h0a3.838,3.838,0,0,1,3.831-3.831h45.261a3.818,3.818,0,0,1,3.831,3.831Z",
    transform: "translate(-525.235 -326.541)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 89.028,
    height: 0.909,
    transform: "translate(81.138 15.098)",
    fill: "#f1c400"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M694.894,742.087a4.2,4.2,0,0,1-3.961-.487s-4.708.747-6.072,2.143-.39,2.078,1.331,2.046c1.688-.032,8.279-.1,8.279-.1S696.128,744.652,694.894,742.087Z",
    transform: "translate(-358.741 -303.555)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M758.258,736s-1.006,1.3-3.247.552c0,0-4.968,2.273-5.844,3.994s.26,2.11,1.883,1.558,7.857-2.533,7.857-2.533S760.206,738.111,758.258,736Z",
    transform: "translate(-402.396 -299.773)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(252.775 334.341)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(262.451 358.433)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(262.451 356.095)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(252.775 380.868)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(252.775 378.531)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(252.775 385.544)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 0.519,
    cy: 0.519,
    r: 0.519,
    transform: "translate(252.775 383.206)",
    fill: "#0b4870"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1.656,
    cy: 1.656,
    r: 1.656,
    transform: "translate(251.639 379.732)",
    fill: "none",
    stroke: "#f1c400",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M660.482,389.359a2.326,2.326,0,0,0,.357,3.279,1.97,1.97,0,0,0,.325.227l-1.364,8.15,3.929-1.753.682-7.468a2.3,2.3,0,0,0-1.136-3.084A2.275,2.275,0,0,0,660.482,389.359Z",
    transform: "translate(-342.251 -65.083)",
    fill: "#ffe0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M760.74,712.37h-3.214L756,700h4.74Z",
    transform: "translate(-407.216 -275.462)",
    fill: "#ffe0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M751.625,739.056H741.3v-.13a4.025,4.025,0,0,1,4.026-4.026h6.3Z",
    transform: "translate(-397.289 -299.03)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M694.508,712.37h-3.182L689.8,700h4.708Z",
    transform: "translate(-362.51 -275.462)",
    fill: "#ffe0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M685.325,739.056H675v-.13a4.025,4.025,0,0,1,4.026-4.026h6.3Z",
    transform: "translate(-352.515 -299.03)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M691.623,560.4l-1.2,1.591s-.1.747-1.916,6.721L687.5,613.778h6.039l8.052-36.072,8.377,36.787,5.227.292L714.936,573s.649-8.6-1.688-10.2S691.623,560.4,691.623,560.4Z",
    transform: "translate(-360.957 -181.188)",
    fill: "#0e538c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 6.331,
    cy: 6.331,
    r: 6.331,
    transform: "translate(331.514 340.251) rotate(-80.782)",
    fill: "#ffe0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M716.272,404.132l-.1-.195a37.446,37.446,0,0,1-1.656-3.7l-1.688.195h-4.383l.617-.909-1.623.195a3.961,3.961,0,0,0-1.656.617,2.454,2.454,0,0,0-.747.779c-.584.974-1.461,2.6-1.461,2.63l-.1.162-.747-1.234c0-.032-.909-4.773,2.11-6.364a4.839,4.839,0,0,1,4.643-2.63A2.05,2.05,0,0,1,710.85,393a2.892,2.892,0,0,1,2.208,1.136,18.007,18.007,0,0,1,3.182,4.059l.227.325a2.535,2.535,0,0,1,.455,1.591,5.425,5.425,0,0,1-.195,2.695Z",
    transform: "translate(-371.157 -68.135)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M710.691,447.4l3.507,1.948,6.883,1.916-2.046,17.987.39,17.728s-11.656,7.987-22.825-1.331V463.342l.649-12.078s2.662-.747,4.026.552l2.565-3.312Z",
    transform: "translate(-367.102 -104.877)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M667.373,424.894l-1.526-1.656-8.507-.974.779-13.052-4.643-3.312L650.1,424.31l15.715,11.007Z",
    transform: "translate(-335.7 -76.851)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M756.321,565.385a2.348,2.348,0,0,1,1.851-2.727,1.719,1.719,0,0,1,.422-.032l2.63-7.825,2.662,3.377L761,565.093a2.361,2.361,0,0,1-4.675.292Z",
    transform: "translate(-407.407 -177.406)",
    fill: "#ffe0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M761.029,461.446l2.6-2.046a8.041,8.041,0,0,1,3.442,4.059c.812,2.6,2.208,17.5,2.208,17.5l-3.831,19.091-4.286-2.955,2.045-15.13-3.6-11.072Z",
    transform: "translate(-409.647 -112.981)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 65.164,
    height: 15.845,
    transform: "translate(253.814 317.718)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M468.7,388.7h61.755V376.3H468.7Z",
    transform: "translate(-213.198 -56.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 4.74,
    cy: 4.74,
    r: 4.74,
    transform: "translate(262.548 320.899)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 31.657,
    height: 1.039,
    transform: "translate(278.587 323.789)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 31.657,
    height: 1.039,
    transform: "translate(278.587 326.451)",
    fill: "#f1c400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b9910470-ced5-4346-b4bb-f41b58844e24-304",
    d: "M420,444.9l55.131,4.026v14.481L420,462.368Z",
    transform: "translate(-180.31 -103.188)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bc7e8449-b99b-4317-a70a-91d17db61b29-305",
    d: "M425.4,464.737,477.609,466v-11.4L425.4,451.1Z",
    transform: "translate(-183.956 -107.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a430bd6b-b2b0-4af3-a079-7f5fd15b0624-306",
    d: "M451.313,458.258a3.909,3.909,0,0,1,1.721.487,5.235,5.235,0,0,1,1.4,1.136,6.238,6.238,0,0,1,.942,1.623,5.909,5.909,0,0,1,0,3.864,4.145,4.145,0,0,1-.942,1.526,4.264,4.264,0,0,1-1.4,1.007,3.961,3.961,0,0,1-1.721.325,4.134,4.134,0,0,1-1.753-.454,4.428,4.428,0,0,1-1.429-1.136,5.3,5.3,0,0,1-.974-1.656A5.926,5.926,0,0,1,446.8,463a5.6,5.6,0,0,1,.357-1.948,4.853,4.853,0,0,1,.974-1.558,4.074,4.074,0,0,1,1.429-1.007A3.967,3.967,0,0,1,451.313,458.258Z",
    transform: "translate(-198.408 -112.196)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af019097-0949-417a-9d8d-f710312ce60c-307",
    d: "M492.3,469.3l25.423,1.331v.974L492.3,470.371Z",
    transform: "translate(-229.135 -119.666)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f94f3612-92b8-42d6-ae14-2a9ea684588e-308",
    d: "M492.3,477.7l25.423,1.1v.974L492.3,478.771Z",
    transform: "translate(-229.135 -125.339)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb553635-e14d-4b1e-b72c-855829e3ad86-309",
    d: "M420,533.339l55.131-1.039v14.481L420,550.807Z",
    transform: "translate(-180.31 -162.211)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e92d7e39-9dcb-4c0c-b0b9-55aac094bc0c-310",
    d: "M425.4,552.2l52.209-3.507V537.3L425.4,538.566Z",
    transform: "translate(-183.956 -165.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f8649409-803b-4d56-993a-4da6ceb3c345-311",
    d: "M446.787,550.168a5.6,5.6,0,0,1,1.494-3.571,4.161,4.161,0,0,1,1.461-1.039,4.04,4.04,0,0,1,1.753-.357,3.821,3.821,0,0,1,1.688.422,3.979,3.979,0,0,1,1.331,1.1,4.758,4.758,0,0,1,.877,1.591,5.468,5.468,0,0,1,.26,1.916,5.643,5.643,0,0,1-.422,1.916,5.491,5.491,0,0,1-1.006,1.591,4.245,4.245,0,0,1-1.429,1.071,4.623,4.623,0,0,1-1.721.422,3.927,3.927,0,0,1-1.721-.39,4.463,4.463,0,0,1-1.4-1.071,4.986,4.986,0,0,1-.909-1.623A5.942,5.942,0,0,1,446.787,550.168Z",
    transform: "translate(-198.395 -170.923)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f70c4d59-0dd2-4f0b-ba41-17bf719deab5-312",
    d: "M492.3,551.207l25.423-1.006v.974l-25.423,1.1Z",
    transform: "translate(-229.135 -174.299)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba176e8f-fd02-45f1-a5f1-dcef4bb8b7ed-313",
    d: "M462.6,559.334l25.423-1.234v.974L462.6,560.405v-1.071Z",
    transform: "translate(-209.078 -179.634)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M718.788,747.49H642.195a.195.195,0,1,1,0-.39h76.593a.195.195,0,0,1,0,.39Z",
    transform: "translate(-330.23 -307.269)",
    fill: "#cacaca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.3c17960e57683747dcecb4f454200592.svg";
export { ForwardRef as ReactComponent };